import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

const usePlannedTimes = (plannedClockIn: string, plannedClockOut: string) => {
  const { access } = useCurrentSession()

  const plannedClockInTime = moment(plannedClockIn).utcOffset(plannedClockIn)
  const plannedClockOutTime = moment(plannedClockOut).utcOffset(plannedClockIn)

  const isTimeFormat24H = access.timeFormat === 24
  const formatTime = isTimeFormat24H ? 'HH:mm' : 'hh:mm A'
  const plannedClockInFormatted = plannedClockInTime.format(formatTime)
  const plannedClockOutFormatted = plannedClockOutTime.format(formatTime)

  return {
    plannedClockInFormatted,
    plannedClockOutFormatted,
  }
}

export default usePlannedTimes
